module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/mens_hairmake-acebe31af4e38405f98ae293daff5873.jpg";